import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Booking from './Booking';
import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import { closeCancelBookingModal, closeCancelScheduledBookingModal } from '../../../actions/siteadmin/modalActions';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.bookingsMenu);

    //From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account && store.getState().account.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;
    store.dispatch(closeCancelBookingModal());
    store.dispatch(closeCancelScheduledBookingModal());

    if (!isAdminAuthenticated) {
        return { redirect: '/login' }
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/jobs', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <Booking />
            </AdminLayout>
        ),
    }
}

export default action;